import React from "react";

interface DisabledFieldProps {
  label: string;
  value: string;
}

const DisabledField: React.FC<DisabledFieldProps> = ({ label, value }) => {
  return (
    <div className="mb-3 sm:mb-4">
      <label htmlFor="disabledField" className="block text-foreground font-medium mb-1 sm:mb-2 text-xs sm:text-sm md:text-base">
        {label}
      </label>
      <input
        id={`disabledField-${Math.random().toString(36).substr(2, 9)}`}
        type="text"
        value={value}
        disabled
        aria-disabled="true"
        className="w-full px-3 py-1.5 sm:px-4 sm:py-2 bg-accent text-accent-foreground border border-primary/20 rounded-md cursor-not-allowed focus:outline-none text-xs sm:text-sm md:text-base"
        title="This field is disabled for editing."
      />
    </div>
  );
};

export default DisabledField;